import { createSelector } from 'reselect';

/**
 * Direct selector to the notificaions state domain
 */
const selectNotificationsDomain = () => (state) => state.get('notification');

/**
 * Other specific selectors
 */

/**
 * Default selector used by Notificaions
 */

const selectNotifications = () =>
  createSelector(selectNotificationsDomain(), (substate) => substate.toJS());

export { selectNotificationsDomain, selectNotifications };
